import React from 'react';
interface SacredGeometryProps {
  className?: string;
  color?: string;
}
export function SacredGeometry({
  className = '',
  color = '#00A99D'
}: SacredGeometryProps) {
  return <svg className={className} viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
    opacity: 0.05
  }} data-id="element-369">
      <circle cx="100" cy="100" r="90" stroke={color} strokeWidth="1" data-id="element-370" />
      <circle cx="100" cy="55" r="45" stroke={color} strokeWidth="1" data-id="element-371" />
      <circle cx="100" cy="145" r="45" stroke={color} strokeWidth="1" data-id="element-372" />
      <circle cx="61" cy="77.5" r="45" stroke={color} strokeWidth="1" data-id="element-373" />
      <circle cx="139" cy="77.5" r="45" stroke={color} strokeWidth="1" data-id="element-374" />
      <circle cx="61" cy="122.5" r="45" stroke={color} strokeWidth="1" data-id="element-375" />
      <circle cx="139" cy="122.5" r="45" stroke={color} strokeWidth="1" data-id="element-376" />
      <circle cx="100" cy="100" r="45" stroke={color} strokeWidth="1" data-id="element-377" />
    </svg>;
}